import { cn } from '@/shared/utils';
import type { TextareaBaseProps } from '@/view/shared/form/Textarea.props';

export function TextareaBase({
  value,
  onChange,
  onKeyDown,
  placeholder,
  rows = 5,
  id,
  classNames,
}: Readonly<TextareaBaseProps>) {
  return (
    <div className={classNames?.container ?? ''}>
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder ?? ''}
        rows={rows}
        className={cn(
          'w-full border border-input rounded-lg px-3 py-2 bg-card text-foreground',
          'focus:outline-none focus:ring-2 focus:ring-ring focus:border-primary transition-all',
          'placeholder:text-muted-foreground text-xs sm:text-sm font-normal leading-normal resize-none',
          classNames?.textarea,
        )}
      />
    </div>
  );
}
